export const aciToRGB: Record<number, string> = {
  1: "#FF0000",   // Red
  2: "#FFFF00",   // Yellow
  3: "#00FF00",   // Green
  4: "#00FFFF",   // Cyan/Aqua
  5: "#0000FF",   // Blue
  6: "#FF00FF",   // Magenta
  7: "#FFFFFF",   // White
  8: "#414141",   // Dark Gray
  9: "#808080",   // Gray
  10: "#FF0000",  // Red
  11: "#FFAAAA",  // Light Red
  20: "#FFFF00",  // Yellow
  21: "#FFFFAA",  // Light Yellow
  30: "#00FF00",  // Green
  31: "#AAFFAA",  // Light Green
  40: "#00FFFF",  // Cyan
  41: "#AAFFFF",  // Light Cyan
  50: "#0000FF",  // Blue
  51: "#AAAAFF",  // Light Blue
  60: "#FF00FF",  // Magenta
  61: "#FFAAFF",  // Light Magenta
  70: "#FFFFFF",  // White
  71: "#FFFFFF",  // Light White
  80: "#414141",  // Dark Gray
  90: "#808080",  // Gray
  256: "#FFFFFF"  // ByLayer
};